import React from "react";

export default function InsightTop10MSAs({ data }) {
    const rows = data ?? [];

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    return (
        <div className="hc-box">
            <div className="hc-title">Top 10 MSA</div>
            <div className="hc-body">
                <table className="hc-table">
                    <tbody>
                    {rows.map((r, i) => (
                        <tr className="hc-row" key={i}>
                            <td className="hc-desc" title={r.msa}>
                                {r.msa}
                            </td>
                            <td className="hc-cnt">
                                {r.count?.toLocaleString()}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <style>{`
        .hc-box {
          border: 1px solid #d3d3d3;
          border-radius: 3px;
          background: #ffffff;
          font-family: sans-serif;
          font-size: 12px;
          overflow: hidden;
        }
        .hc-title {
          font-size: 16px;
          font-weight: 700;
          padding: 6px 10px;
          border-bottom: 1px solid #d3d3d3;
          background: #f5f5f5;
        }
        .hc-body {
          max-height: 600px;
          overflow-y: hidden;
          padding: 2px 3px;
        }
        .hc-table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          padding: 6px 8px;
        }
        .hc-desc {
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .hc-cnt {
          text-align: right;
          font-weight: 600;
          width: 120px;
        }

        /* Zebra stripes - apply to both columns */
        .hc-row:nth-child(odd) td { background: #f7fbff; }
        .hc-row:nth-child(even) td { background: #eef5fb; }
      `}</style>
        </div>
    );
}
